module.exports = __webpack_public_path__ + "static/media/autokar3 (7).64dd246c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (7).jpg
// module id = 863
// module chunks = 0